import refs from '../helpers/refs'
import Form from '../helpers/form'
import site from '../helpers/site'
import '../atoms/a-input-date'
import '../atoms/a-input-select'
import '../atoms/a-input-text'

class CContactForm {
  constructor (el) {
    this.component = el
    this.$refs = refs(this.component)
    this.site = site()

    this.init()
  }

  init () {
    // Country/state behavior
    Form.handleCountryStateZip(this.$refs.countryDropdown)
    Form.handleCountrySubsidiary()
    // Email validation behavior
    Form.handleEmailFieldMatching()
    // Newsletter behavior
    Form.handleNewsletterOptIn()
    // File validation
    Form.handleFileValidation(['product', 'issue', 'additional'])

    if (this.site === 'masterbuilt') {
      // Product + type dropdowns
      Form.handleMBProductTypeDropdown()
      // Model number select or entry
      Form.handleMBModelNumber()
    } else if (this.site === 'chargriller') {
      // Product + type dropdowns
      Form.handleCGProductTypeDropdown()
      // Model number select or entry
      Form.handleCGModelNumber()
    } else {
      // Product + type dropdowns
      Form.handleKJProductTypeDropdown()
      // Model number select or entry
      Form.handleKJModelNumber()
    }

    // Topic select handler
    this.handleTopicDropdowns()

    this.component.querySelector('#support-form').addEventListener('submit', (event) => {
      const isValid = this.validateForm()

      if (!isValid) {
        event.preventDefault()
      } else {
        const zipFieldValue = document.querySelector('#zip-field').value
        const helpTopicValue = document.querySelector('#help-topic').value
        const helpTopicLabel = document.querySelector(`#help-topic option[value="${helpTopicValue}"]`).innerText

        window.dataLayer.push({
          event: 'contact_form_submit',
          event_category: 'contact_form_submit',
          event_action: zipFieldValue,
          event_label: helpTopicLabel
        })
      }

      return isValid
    })

    this.captchaKey = this.setCaptchaKey()
  }

  setCaptchaKey () {
    if (this.site === 'masterbuilt') {
      this.captchaKey = '6LdrdzAiAAAAAElYWgOBfidmZzKYMW1uu-I172pZ'
    } else if (this.site === 'kamadojoe') {
      this.captchaKey = '6LcVfTAiAAAAAP0J4QGcbTC2P3mr6XZI0wyRimBV'
    } else {
      // CharGriller
      this.captchaKey = '6LcCgjAiAAAAACshd3V-8Bc8ffIv8XKvl9Jiwxp3'
    }
  }

  handleTopicDropdowns () {
    const helpTopic = this.component.querySelector('#help-topic')

    helpTopic.addEventListener('change', (event) => {
      if (event.target.value === '9' || event.target.value === '12') {
        document.querySelector('#case-issue').setAttribute('value', 4)
      } else {
        document.querySelector('#case-issue').setAttribute('value', 56)
      }
      this.checkRequireWarrantyImages()
    })
  }

  removeRequiredPurchasePlace (hideStar) {
    const purchasePlaceLabel = document.querySelector('#purchase-place-label')
    // const imageFieldLabel = document.querySelector('#product-image-label')
    const requiredStar = ' *'
    const noStarPurchasePlace = purchasePlaceLabel.innerHTML.replace(requiredStar, '')
    const withStarPurchasePlace = noStarPurchasePlace + requiredStar
    // const noStarImageField = imageFieldLabel.innerHTML.replace(requiredStar, '')
    // const withStarImageField = noStarImageField + requiredStar

    // no * by default
    if (hideStar) {
      purchasePlaceLabel.innerHTML = noStarPurchasePlace
      // imageFieldLabel.innerHTML = noStarImageField
    } else {
      purchasePlaceLabel.innerHTML = withStarPurchasePlace
      // imageFieldLabel.innerHTML = withStarImageField
    }
  }

  checkRequireWarrantyImages () {
    const helpTopic = document.querySelector('#help-topic')
    const image1 = document.querySelector('#image-field') // "Attach an image of your product"
    const image1Label = document.querySelector('#product-image-label')
    const image1Hint = document.querySelector('#product-image-hint')
    image1Hint.innerText = 'For warranty service, attach an image of your product.'
    const image2 = document.querySelector('#addl-image-1-field') // "Attach an image of the issue"
    const image2Label = document.querySelector('#addl-image-1-field-label')
    const image2Hint = document.querySelector('#addl-image-1-field-hint')
    image2Hint.innerText = 'For warranty service, attach an image of the issue.'
    const requiredStar = ' *'
    const image1NoStar = image1Label.innerHTML.replace(requiredStar, '')
    const image2NoStar = image2Label.innerHTML.replace(requiredStar, '')
    const image1WithStar = image1NoStar + requiredStar
    const image2WithStar = image2NoStar + requiredStar

    if (helpTopic.value === '10') {
      alert('You must submit an image of your product and an image of your issue for warranty service.')
      image1.setAttribute('required', true)
      image2.setAttribute('required', true)
      image1Label.innerHTML = image1WithStar
      image2Label.innerHTML = image2WithStar
      image1Hint.classList.remove('hidden')
      image2Hint.classList.remove('hidden')
    } else {
      image1.removeAttribute('required')
      image2.removeAttribute('required')
      image1Label.innerHTML = image1NoStar
      image2Label.innerHTML = image2NoStar
      image1Hint.classList.add('hidden')
      image2Hint.classList.add('hidden')
    }
  }

  validateForm () {
    // change style of button so can tell it's been clicked
    document.querySelector('#submit-btn').setAttribute('disabled', true)
    document.querySelector('.please-wait').classList.remove('hidden')
    const purchaseDateField = document.getElementById('purchase-date-field')
    const zipField = document.getElementById('zip-field')
    const firstName = document.getElementById('first-name-field').value
    const lastName = document.getElementById('last-name-field').value
    let formIsValid = true

    // Clear previous error messages
    Form.hideAllErrors()

    // Check required fields
    formIsValid = Form.validateRequiredFields(this.component)

    // If all required fields are present, validate values entered
    if (formIsValid) {
      if (purchaseDateField.value.length > 0) {
        Form.formatDate(purchaseDateField)
      }

      if (!(formIsValid &&= Form.validZip(zipField.value))) {
        Form.showError(zipField.closest('.a-input-text'), 'Please input a valid zip code.')
      }

      formIsValid &&= Form.validateEmail()
      formIsValid &&= Form.validateFileSizes(['product', 'issue', 'additional'])
      formIsValid &&= Form.validateFileFormat()
      formIsValid &&= Form.validateBannedName(firstName, lastName)
    }

    // re-enable submit button
    document.querySelector('#submit-btn').removeAttribute('disabled')
    document.querySelector('.please-wait').classList.add('hidden')

    if (!formIsValid) {
      // Set focus on the first error field
      Form.focusFirstError(this.component)
    }

    return formIsValid
  }

  formSubmitBtn ($event) {
    /**
     * Checks the validity of the form.
     * Return if invalid; HTML5 validation errors should display.
     */
    // The liquid code includes a novalidate parameter and custom checks so turning this off
    // if (!$event.target.form.checkValidity()) {
    //   return
    // }

    /**
     * Form is client-side valid; taking over the remainder of processing.
     */
    $event.preventDefault()
    grecaptcha.ready(function () {
      grecaptcha.execute(this.captchaKey, { action: 'submit' }).then(function (token) {
      /**
       * Adds the token custevent_recaptcha_token token to our hidden form element.
       * ** Notice ** we our referencing the specific form's input element by name here (do not use IDs).
       */
        $event.target.form.elements.custevent_recaptcha_token.value = token
        /**
     * Checks the validity of zip, email, file sizes, etc.
     * Defined in each form file
     * Works when here, but not when run after checkValidity().
         * Don't know why, no more time to spend on it.
         */
        const valid = validateForm()
        if (valid) {
          /**
           * Use the form API directly to submit the form.
          */
          $event.target.form.submit()
        }
      })
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-contact-form')
    .forEach(el => new CContactForm(el))
})
